export default __webpack_public_path__ + "static/media/action-delete-icon.ea65dc7c.svg";